import { render } from "./InputList.vue?vue&type=template&id=489f790b&scoped=true"
import script from "./InputList.vue?vue&type=script&lang=ts"
export * from "./InputList.vue?vue&type=script&lang=ts"

import "./InputList.vue?vue&type=style&index=0&id=489f790b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-489f790b"

export default script